module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "list__scroll"
  }, [_vm._m(0), _c('div', {
    staticClass: "list__item"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('MentoringListItem', {
      key: index,
      attrs: {
        "item": item,
        "index": index + 1
      }
    })
  }), 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list__item list__item_padding"
  }, [_c('div', {
    staticClass: "list__line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65a2755e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/programcard/components/main/components/list/MentoringList.vue
// module id = 4f6991934278744cb4ee
// module chunks = 89